// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ExecutionsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for executions /payroll/executions
 * Returns array of payment rule executions for a period
 */
import type { Payroll_ExecutionRow } from './Payroll_ExecutionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_ExecutionsResponseDados = Payroll_ExecutionRow[];

export type Payroll_ExecutionsResponse = ApiResponse<Payroll_ExecutionsResponseDados>;

registerResponseContract('Payroll_ExecutionsResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      id:                { type: 'number',  required: true },
      payroll_period_id: { type: 'number',  required: true },
      payment_rule_id:   { type: 'number',  required: true },
      user_id:           { type: 'string',  required: true },
      franchise_id:      { type: 'number',  required: true },
      despesa_id:        { type: 'number',  required: false },
      base_amount:       { type: 'string',  required: true },
      revenue_tracked:   { type: 'string',  required: false },
      expenses_tracked:  { type: 'string',  required: false },
      total_deductions:  { type: 'string',  required: true },
      net_amount:        { type: 'string',  required: true },
      calculation_meta:  { type: 'string',  required: false },
      status:            { type: 'string',  required: true },
      paid_at:           { type: 'string',  required: false },
      created_at:        { type: 'string',  required: true },
      updated_at:        { type: 'string',  required: true },
      rule_type:         { type: 'string',  required: false },
      rule_amount:       { type: 'string',  required: false },
    },
  },
})
